import React from 'react';
import { useEffect, useState } from 'react';
import copy from 'copy-to-clipboard';

import { Button, Input } from '../../elements';
import { setLoading } from '../../redux/loading/loadingActions';
import { useAppSelector, useAppDispatch } from '../../hooks/useRedux';
import { showError, showSuccess } from '../../elements/Toasts/toastActions';
import { ReactComponent as DeletIcon } from '../../styles/icon/delete.svg';
import { ReactComponent as SaveIcon } from '../../styles/icon/save.svg';
import { ReactComponent as RefreshIcon } from '../../styles/icon/refresh.svg';
import strings from '../../lang/lang';
import {
  appsActions,
  appDetailsData,
  appDescriptionData
} from '../../redux/reducers/apps';

import settings from './Settings.module.scss';

function Credentials() {
  const [appId, setAppId] = useState(undefined);
  const [isBlocked, setIsBlocked] = useState(false);

  const dispatch = useAppDispatch();
  const data = useAppSelector(appDetailsData);
  const appDescription = useAppSelector(appDescriptionData);

  useEffect(() => {
    if (data) {
      setAppId(data.id);
      setIsBlocked(data.status === 'BLOCKED');

      if (appDescription !== data.description) {
        dispatch(appsActions.setAppDescription(appDescription));
      }
    }
  }, [data]);

  const updateDescription = () => {
    setLoading(true);

    return new Promise((res, rej) => {
      const description = appDescription ? appDescription.trim() : appDescription;
      dispatch(appsActions.updateAppDetails({
        appId,
        data: { description },
        res,
        rej,
      }));
    })
    .then(() => {
      showSuccess(strings.appCredentials.text.successSaving);
    })
    .catch(() => {
      showError(strings.appCredentials.errors.updatingDescription);
      dispatch(appsActions.setAppDescription(''));
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const clientIdValue = (data && data['appId']) || '';
  const clientSecretValue = (data && data['clientSecret']) || '';
  const publicIdValue = (data && data['publicClientId']) || 'public-cli';

  return (
    <div className={settings.settings__wrap}>
      <h2>{strings.appCredentials.text.title}</h2>
      <Input
        id="appName"
        className="input__textfield__settings"
        name="App name"
        label={strings.appCredentials.fields.appName}
        autoComplete="off"
        value={(data && data.name) || ''}
        disabled
      />
      <div
        className={settings.settings__textarea}
        style={isBlocked ? { pointerEvents: 'none', opacity: 0.4 } : {}}
      >
        <label htmlFor="description">{strings.appCredentials.fields.description}</label>
        <textarea
          id="description"
          name="description"
          placeholder={strings.appCredentials.text.descriptionPlaceholder}
          value={appDescription || ''}
          onChange={(e) => dispatch(appsActions.setAppDescription(e.target.value))}
          maxLength={512}
        />
      </div>
      <h3>{strings.appCredentials.text.appCredentialsTitle}</h3>
      <p>{strings.appCredentials.text.appCredentialsDescription}</p>
      <div
        className={settings.settings__input}
        style={isBlocked ? { pointerEvents: 'none', opacity: 0.4 } : {}}
      >
        <Input
          id="clientId"
          name="clientId"
          label={strings.appCredentials.fields.clientId}
          className="input__textfield__settings"
          thirdClassName="input__textfield__client"
          autoComplete="off"
          value={clientIdValue}
          readOnly
          onClickInputValue={(e) => {
            copy(clientIdValue);
            showSuccess(strings.appCredentials.text.copied);
          }}
        />
      </div>
      <div style={isBlocked ? { pointerEvents: 'none', opacity: 0.4 } : {}}>
        <Input
          id="clientSecret"
          name="clientSecret"
          type="text"
          label={strings.appCredentials.fields.clientSecret}
          className="input__textfield__settings"
          secondaryClassName="input__textfield__secret"
          thirdClassName="input__textfield__client"
          autoComplete="off"
          value={clientSecretValue}
          onClick={() => dispatch(appsActions.toogleGenerateSecretModal(true))}
          onClickInputValue={() => {
            copy(clientSecretValue);
            showSuccess(strings.appCredentials.text.copied);
          }}
          readOnly
          isTypeFieldPasswordCredentials
          refreshSecret={<RefreshIcon />}
        />
      </div>
      {data['type'] === 'B2C' && (
        <>
          <h3>{strings.appCredentials.text.publicClientTitle}</h3>
          <p>{strings.appCredentials.text.publicClientDescription}</p>
          <div
            className={settings.settings__input}
            style={isBlocked ? { pointerEvents: 'none', opacity: 0.4 } : {}}
          >
            <Input
              id="publicClientId"
              name="publicClientId"
              label={strings.appCredentials.fields.clientId}
              className="input__textfield__settings"
              thirdClassName="input__textfield__client"
              autoComplete="off"
              value={publicIdValue}
              onClickInputValue={() => {
                copy(publicIdValue);
                showSuccess(strings.appCredentials.text.copied);
              }}
              readOnly
            />
          </div>
        </>
      )}
      <div className={settings.settings__info}>
        <h3>{strings.appCredentials.text.dangerZone}</h3>
        <div className={settings.settings__danger}>
          <div className={settings.settings__danger_text}>
            <strong>{strings.appCredentials.text.deleteTitle}</strong>
            <p>{strings.appCredentials.text.deleteDescription}</p>
          </div>
          <Button
            name={strings.appCredentials.buttons.delete}
            variant="delete"
            type="submit"
            onClick={() => dispatch(appsActions.toogleDeleteAppModal(true))}
          >
            <DeletIcon />
          </Button>
        </div>
      </div>
      <div>
        <Button
          name={strings.appCredentials.buttons.save}
          variant="primary"
          secondaryClassName="lg"
          onClick={() => updateDescription()}
          disabled={isBlocked}
        >
          <SaveIcon />
        </Button>
      </div>
    </div>
  );
}

export default Credentials;
